import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Building2, Settings2 } from "lucide-react";
import { toast } from "sonner";

export function SpaceSwitcher({ user }) {
  const [spaces, setSpaces] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const load = () => api.get("/spaces").then(({ data }) => setSpaces(data.filter((s) => s.active !== false))).catch(() => setSpaces([]));
    load();
    window.addEventListener("spaces-changed", load);
    return () => window.removeEventListener("spaces-changed", load);
  }, [user?.tenant_id]);
  const current = spaces.find((s) => s.entreprise_id === user?.tenant_id);
  const change = async (id) => {
    if (id === user?.tenant_id) return;
    setBusy(true);
    try {
      const { data } = await api.post("/spaces/switch", { entreprise_id: id });
      toast.success(`Espace actif : ${data.nom}`);
      window.location.assign("/dashboard");
    } catch (e) { toast.error(e?.response?.data?.detail || "Bascule impossible"); setBusy(false); }
  };
  const away = user?.home_tenant_id && user?.tenant_id !== user?.home_tenant_id;
  return (
    <div data-testid="space-switcher-bar" className={`flex flex-wrap items-center gap-2 px-4 sm:px-8 py-2 border-b text-sm ${away ? "bg-[#FFB020]/10 border-[#FFB020]/30" : "bg-zinc-900 border-white/10"}`}>
      <Building2 className="w-4 h-4 text-[#007AFF]" />
      <span className="text-zinc-400">Espace entreprise :</span>
      <select value={user?.tenant_id || ""} disabled={busy || spaces.length === 0} onChange={(e) => change(e.target.value)}
        data-testid="space-switcher-select" className="h-8 rounded-md border border-zinc-700 bg-zinc-900 px-2 text-sm font-medium text-white focus:outline-none focus:border-[#007AFF]">
        {spaces.length === 0 && <option value={user?.tenant_id || ""}>…</option>}
        {spaces.map((s) => <option key={s.entreprise_id} value={s.entreprise_id}>{s.nom}{s.pays ? ` (${s.pays})` : ""}</option>)}
      </select>
      {away && current && <span data-testid="space-away-badge" className="text-xs text-[#FFB020]">Vous travaillez dans l'espace {current.nom}</span>}
      <Link to="/dashboard/espaces" data-testid="space-manage-link" className="ml-auto inline-flex items-center gap-1 text-xs text-[#007AFF] hover:underline">
        <Settings2 className="w-3.5 h-3.5" /> Gérer les espaces
      </Link>
    </div>
  );
}
